module.exports = __webpack_public_path__ + "img/permisson-comparison3.b1184e01.jpg";